import { Trans } from "react-i18next"
import { Checkbox } from "@/components/ui/checkbox"

type TermsCheckboxProps = {
  accepted: boolean
  onAcceptedChange: (accepted: boolean) => void
}

export const TermsCheckbox = ({ accepted, onAcceptedChange }: TermsCheckboxProps) => {
  return (
    <label className="flex items-start gap-2 text-sm">
      <Checkbox
        checked={accepted}
        onCheckedChange={(checked) => onAcceptedChange(checked === true)}
        className="mt-0.5"
      />
      <span className="text-muted-foreground">
        <Trans
          i18nKey="landing.login.terms_agreement"
          components={{
            terms: (
              <a
                href="https://ai.mitigate.dev/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              />
            ),
            privacy: (
              <a
                href="https://ai.mitigate.dev/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              />
            )
          }}
        />
      </span>
    </label>
  )
}
